export default "__VITE_ASSET__lmu1gBRv__"